import React from 'react';
import PropTypes from 'prop-types';
import AssetTile from '../../../js/react-components/AssetTile';

function AssetContainer({
    assetOptions = [],
    editable = false,
    deletable = true,
    legacy = false,
    editAsset = () => {},
    selectAsset = () => {},
    deleteAsset = () => {},
}) {
    const renderAssetTiles = assetOptions.map((asset) => <AssetTile
        key={asset.id}
        asset={asset}
        editable={editable || asset.is_editable}
        deletable={deletable || asset.can_delete}
        legacy={legacy}
        editAsset={editAsset}
        selectAsset={selectAsset}
        deleteAsset={deleteAsset}
    />);

    return (
        <>{renderAssetTiles}</>
    );
}

AssetContainer.propTypes = {
    assetOptions: PropTypes.array.isRequired,
    editable: PropTypes.bool,
    deletable: PropTypes.bool,
    legacy: PropTypes.bool,
    editAsset: PropTypes.func.isRequired,
    selectAsset: PropTypes.func,
    deleteAsset: PropTypes.func.isRequired,
};

export default AssetContainer;
